module.exports = (__webpack_require__(76833))(506);